import { Navigate, Outlet } from 'react-router-dom'
import { getCurrentUser } from '../lib/auth'

export function AuthGuard() {
  const user = getCurrentUser()
  if (!user) return <Navigate to="/login" replace />
  return <Outlet />
}

export function AdminGuard() {
  const user = getCurrentUser()
  if (!user) return <Navigate to="/login" replace />
  if (user.role !== 'super_admin') return <Navigate to="/dashboard" replace />
  return <Outlet />
}
